module.exports = __webpack_public_path__ + "img/0Q3A3733_L_BlackMatted.1d9e678d.jpg";